<template>
  <div>
    <NumberFormGroup
        :value="value.limit"
        name="limit"
        label="Limit"
        :error="(errors.limit || [])[0]"
        help-text="The number of items to display before the 'Load more' button appears. Clicking 'Load more' will also load this number of items."
        @input="emit('limit', $event)"
    />

    <NumberFormGroup
        :value="value.offset"
        name="offset"
        label="Offset"
        :error="(errors.offset || [])[0]"
        help-text="The number of items to skip, before getting the items to display."
        @input="emit('offset', $event)"
    />

    <NumberFormGroup
        :value="value.max"
        name="max"
        label="Max"
        :error="(errors.max || [])[0]"
        help-text="The maximum number of items to display, including 'Load more'. Max must be larger than Limit. If max is empty, an infinite amount of items can be displayed."
        @input="emit('max', $event)"
    />

    <RadioFormGroup
        :value="value.context"
        name="context"
        label="Context"
        :error="(errors.context || [])[0]"
        :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
        @input="emit('context', $event)"
    />

    <RadioFormGroup
        :value="value.featured_only"
        name="featured_only"
        label="Featured Only"
        :error="(errors.featured_only || [])[0]"
        :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
        @input="emit('featured_only', $event)"
    />
  </div>
</template>

<script>
import store from '@/store'
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'

export default {
  components: {NumberFormGroup, RadioFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      shared: store
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
